import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { promosPaginationRequestAction } from '../../actions/pagination';
import { ShowMoreButton } from '../../components/ShowMoreButton';
import { selectIsLoading } from '../../selectors/loading';
import { selectHasNextPage } from '../../selectors/pagination';
import { TThunkDispatch } from '../../types/redux/thunk';

export const ShowMoreButtonContainer = () => {
  const hasNextPage = useSelector(selectHasNextPage);
  const isLoading = useSelector(selectIsLoading);

  const dispatch: TThunkDispatch = useDispatch();

  const loadNextPage = React.useCallback(() => {
    dispatch(promosPaginationRequestAction());
  }, [dispatch]);

  if (!hasNextPage) {
    return null;
  }

  return <ShowMoreButton onClick={loadNextPage} disabled={isLoading} />;
};
